export const genderIdentity = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Non-binary', value: 'Non-binary' },
  { label: "Not Listed", value: "Not Listed" },
];
